import t from "./_getLength.js";
import r from "./isFunction.js";
import e from "./allKeys.js";
function o(o) {
  var a = t(o);
  return function (i) {
    if (null == i || t(e(i))) return !1;
    for (var s = 0; s < a; s++) if (!r(i[o[s]])) return !1;
    return o !== c || !r(i[n]);
  };
}
var n = "forEach",
  a = ["clear", "delete"],
  i = ["get", "has", "set"],
  s = a.concat(n, i),
  c = a.concat(i),
  f = ["add"].concat(a, n, "has");
export { o as ie11fingerprint, s as mapMethods, f as setMethods, c as weakMapMethods };